import clsx from 'clsx';
import { Box, ListItem, Image, Heading, TextLabel } from '@customerio/pluma-components/react';
import { useAnalytics } from '@/services/analytics';
import completionIcon from '@/assets/images/adventures/check.svg';
import { CONFIGS } from '../rocket-configs';
import * as styles from './index.css';

interface Args {
  isComplete: boolean;
  children: React.ReactNode;
  ariaLabel: string;
  onClick?: (event: React.MouseEvent) => void;
  configId: string;
  icon: string;
  stepsCompleted: number;
}

export function AdventuresItem({ children, ariaLabel, onClick, configId, icon, isComplete, stepsCompleted }: Args) {
  const { track } = useAnalytics();

  const handleClick = (event: React.MouseEvent) => {
    void track('rocket', 'tourItemClicked', {
      'Step Label': ariaLabel,
    });

    onClick?.(event);
  };

  const config = CONFIGS.find((config) => config.id === configId);
  const totalSteps = config?.steps.length ?? 0;

  const configIndex = CONFIGS.findIndex((config) => config.id === configId);

  return (
    <ListItem
      className={clsx(styles.adventuresItem, {
        [styles.adventuresItemVariants.complete]: isComplete,
      })}
      p="100"
      onClick={handleClick}
      role="button"
      aria-label={ariaLabel}
      data-config-id={configId}
    >
      <Box display="flex" alignItems="center">
        <Box mr="100" display="flex" alignItems="center" justifyContent="center">
          <Image src={isComplete ? completionIcon : icon} alt="" width="40" height="40" />
        </Box>
        <Box alignItems="center">
          <TextLabel mb="050">
            Adventure {configIndex + 1}
            {stepsCompleted > 0 ? (
              <>
                :{' '}
                <Box
                  as="span"
                  className={clsx(styles.adventuresItemTextCompletion, {
                    [styles.adventuresItemTextCompletionIncomplete]: !isComplete,
                  })}
                >
                  {stepsCompleted} / {totalSteps} complete
                </Box>
              </>
            ) : null}
          </TextLabel>
          <Heading level="4">{children}</Heading>
        </Box>
      </Box>
    </ListItem>
  );
}
